import React from 'react';
import RcTabs from 'rc-tabs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons';
import 'rc-tabs/assets/index.css';
import './styles.scss';
import { TabsProps } from './types';

export const Tabs: React.FC<TabsProps> = ({ children, ...props }) => {
  return (
    <RcTabs
      moreIcon={<FontAwesomeIcon icon={faEllipsisH} size="sm" />}
      {...props}
    >
      {children}
    </RcTabs>
  );
};

export { TabPane } from 'rc-tabs';
